import React from "react";
var TableHeader = function (_a) {
    var columns = _a.columns;
    return (React.createElement("thead", null,
        React.createElement("tr", null, columns.map(function (column, index) {
            return (React.createElement("th", { key: "table-cell-" + index, style: {
                    textAlign: column.align,
                    fontWeight: "bold"
                } }, column.label));
        }))));
};
export default TableHeader;
